export const tareProfileModeValues = [
  'none',
  'fixed_default',
  'manual_required',
  'fixed_asset_master',
] as const;
export type TareProfileMode = (typeof tareProfileModeValues)[number];

export const tareProfileValidationIssueCodeValues = [
  'fixed_default_tare_required',
  'default_tare_not_allowed',
  'invalid_tare_profile_mode',
] as const;
export type TareProfileValidationIssueCode =
  (typeof tareProfileValidationIssueCodeValues)[number];

export interface TareProfileValidationIssue {
  code: TareProfileValidationIssueCode;
  field?: string;
  message: string;
}

export interface TareProfileValidationResult {
  isValid: boolean;
  issues: TareProfileValidationIssue[];
}

export interface TareProfileDto {
  id: string; // UUID
  companyId: string;
  storeId: string;
  locationId: string;
  code: string;
  displayName: string;
  description?: string | null;
  mode: TareProfileMode;
  defaultTareLb?: number | null;
  allowOperatorOverride: boolean;
  requireOperatorConfirmation: boolean;
  isActive: boolean;
  displayOrder: number;
  revision: number;
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
}

export type TareProfileSummaryDto = Pick<
  TareProfileDto,
  | 'id'
  | 'code'
  | 'displayName'
  | 'description'
  | 'mode'
  | 'defaultTareLb'
  | 'allowOperatorOverride'
  | 'requireOperatorConfirmation'
  | 'revision'
>;

export interface ListTareProfilesByLocationRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  includeInactive?: boolean;
}

export interface ListTareProfilesByLocationResponse {
  items: TareProfileDto[];
}

export interface CreateTareProfileRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  code: string;
  displayName: string;
  description?: string | null;
  mode: TareProfileMode;
  defaultTareLb?: number | null;
  allowOperatorOverride?: boolean;
  requireOperatorConfirmation?: boolean;
  isActive?: boolean;
  displayOrder?: number;
}

export interface CreateTareProfileResponse {
  item: TareProfileDto;
}

export interface UpdateTareProfileRequest {
  companyId: string;
  tareProfileId: string;
  displayName?: string;
  description?: string | null;
  mode?: TareProfileMode;
  defaultTareLb?: number | null;
  allowOperatorOverride?: boolean;
  requireOperatorConfirmation?: boolean;
  isActive?: boolean;
  displayOrder?: number;
}

export interface UpdateTareProfileResponse {
  item: TareProfileDto;
}

export interface GetTareProfileResponse {
  item: TareProfileDto;
}
